import type { NetworkKpis } from "@cryptors/api-client";
import { Stack, Typography } from "@mui/material";

import { KpiCard } from "./KpiCard";

const formatLanguages = (languages: NetworkKpis["appLanguages"]) =>
  languages.length > 0
    ? languages
        .slice(0, 4)
        .map(({ code, pct }) => `${code.toUpperCase()} ${pct}%`)
        .join(" · ")
    : "—";

const formatDominantPlayMode = (playMode: NetworkKpis["playMode"]) => {
  const modes = [
    { label: "Solo", count: playMode.solo.count },
    { label: "Famille", count: playMode.family.count },
    { label: "Amis", count: playMode.friends.count },
  ];
  const total = modes.reduce((sum, mode) => sum + mode.count, 0);
  if (total === 0) return "—";

  const dominant = modes.reduce((highest, mode) =>
    mode.count > highest.count ? mode : highest,
  );
  const percentage = Math.round((dominant.count / total) * 1000) / 10;
  return `${percentage}% ${dominant.label}`;
};

interface GeneralPlayerStatsSectionProps {
  data: NetworkKpis;
}

export const GeneralPlayerStatsSection = ({
  data,
}: GeneralPlayerStatsSectionProps) => (
  <Stack gap={2}>
    <Typography variant="h6">Statistiques générales des joueurs</Typography>
    <Stack direction="row" gap={2} flexWrap="wrap">
      <KpiCard
        title="Mode de visite dominant"
        value={formatDominantPlayMode(data.playMode)}
      />
      <KpiCard
        title="Langues choisies dans l'application"
        value={formatLanguages(data.appLanguages)}
      />
      <KpiCard
        title="Âge moyen des utilisateurs"
        value={data.averageAge !== null ? `${data.averageAge} ans` : "—"}
      />
    </Stack>
  </Stack>
);
